import {
  setActiveSortingColumn,
  setSelectedFilters,
  setSortingDirection,
} from "src/redux";

export const loadLocalProjectSettings = (projectId, activeTab, dispatch) => {
  const settingsStr = localStorage.getItem("ws-project-settings");
  const settings = JSON.parse(settingsStr || "[]");
  if (settings && settings.length > 0) {
    const result = settings.find((project) => project?.projectId === projectId);
    if (result && result[activeTab]) {
      dispatch(setActiveSortingColumn(result[activeTab].activeSortingColumn));
      dispatch(setSelectedFilters(result[activeTab].selectedFilters));
      if (result[activeTab].sortingDirection) {
        dispatch(setSortingDirection(result[activeTab].sortingDirection));
      }
    } else if (result && result[activeTab] == null) {
      dispatch(setActiveSortingColumn(""));
      dispatch(setSelectedFilters({}));
      dispatch(setSortingDirection("sortingDescending"));
    }
  }
};
